export default __webpack_public_path__ + "static/media/placeholder_store04-en-web.ae572751.png";